<template>
  <b-modal id="alerts-modal" title="Alerts" size="lg" ok-only>
    <b-table
        size="sm"
        :items="paginatedAlerts"
        :fields="fields"
        small
        striped
    ></b-table>
    <b-pagination
        v-model="currentPage"
        :total-rows="alerts.length"
        :per-page="perPage"
        align="center"
        class="mt-3"
    ></b-pagination>
  </b-modal>
</template>

<script>
export default {
  props: {
    alerts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fields: [
        {key: 'time', label: 'Date'},
        {key: 'message', label: 'Message'},
      ],
      currentPage: 1,
      perPage: 10
    }
  },
  computed: {
    // Пагинация для отображения только части алертов
    paginatedAlerts() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.alerts.slice(start, end);
    }
  }
}
</script>